var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.notificationText)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n"+_vm._s(_vm.notificationText)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }